export default __webpack_public_path__ + "static/media/qt-grey.10d5d6ee.svg";